import { Button } from '../../components';
import styles from '../styles.module.scss';

type SubmitButtonProps = {
    label: string;
    disabled: boolean;
    onClick: () => void;
};

export const SubmitButton = ({ label, disabled, onClick }: SubmitButtonProps) => {
    return (
        <div className={styles.submitBtnWrapper}>
            <Button variant="primary" disabled={disabled} onClick={onClick}>
                {label}
            </Button>
        </div>
    );
};
